import styled from 'styled-components'
import {
	backgroundOrange,
	darkOrange,
	orange,
	gold,
	black,
	textMuted,
	warmTint,
	border1,
	scrimDark,
} from '@/theme/colors'
import { radii, layers } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { Pill } from '@components/Pill'

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 16px;
    background: ${backgroundOrange};
    border-radius: ${radii.inner};
    margin-bottom: 16px;
`

export const HeaderPerson = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`

export const HeaderLabel = styled.span`
    ${text.eyebrow}
    color: ${textMuted};
`

export const HeaderName = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${black};
`

export const HeaderArrow = styled.span`
    color: ${darkOrange};
    font-size: ${fontSizes.headingLg};
    font-weight: 700;
`


export const AmountRow = styled.div`
    text-align: center;
    margin-bottom: 16px;
`

export const Amount = styled.span`
    font-size: ${fontSizes.display};
    font-weight: 700;
    color: ${darkOrange};
`

export const CurrencyCode = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${gold};
    margin-left: 6px;
`

export const DateRow = styled.div`
    text-align: center;
    font-size: ${fontSizes.small};
    color: ${textMuted};
    margin-bottom: 24px;
`

export const DetailsBadge = styled(Pill).attrs({ $tone: 'gold' as const })`
	margin-bottom: 16px;
`

export const ThumbnailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 8px;
    margin-bottom: 24px;
`

export const Thumbnail = styled.div`
    aspect-ratio: 1;
    border-radius: ${radii.small};
    overflow: hidden;
    cursor: pointer;
    border: 1px solid ${border1};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        border-color: ${orange};
    }
`

export const AuditInfo = styled.div`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    border-top: 1px solid ${warmTint};
    padding-top: 12px;
    line-height: ${leading.body};
`

export const AuditLine = styled.div`
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`

export const FooterActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
`

export const ActionButton = styled(Button).attrs({ size: 'sm' as const })``

export const ImageOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: ${scrimDark};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${layers.viewer};
    cursor: pointer;

    img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
    }
`
